module.exports = new __parcel__URL__("insights.tpl.631ac5f4.svg").toString();